import React, { useState, useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';

import InfoButton from '../components/InfoButton';
import StepsDesktop from '../components/StepsDesktop';

import cards from '../data/cards';
import { breakpoints, redirectToLanding, colors } from '../config';
import useMatchMedia from '../useMatchMedia';
import useStore from '../store';

const Steps = ({ platinum, title, subtitle, image, onInfoClick }) => {
  const total = platinum ? 10 : 9;

  const [progress, setProgress] = useState(0);
  const [{ selectedGroup, selectedCard }, setStore] = useStore();

  const isMobile = useMatchMedia(`(max-width: ${breakpoints.md})`);

  let history = useHistory();

  let match = useRouteMatch('/:step');
  let currentStep = match?.params?.step;

  // Prevent browser back button behavior
  useEffect(() => {
    const customBack = () => {
      window.history.pushState(null, document.title, window.location.href);
      history.goBack();
    };

    if (currentStep && parseInt(currentStep) > 1) {
      window.history.pushState(null, document.title, window.location.href);
      window.addEventListener('popstate', customBack);
    }

    return () => {
      window.removeEventListener('popstate', customBack);
    };
  }, [history, currentStep]);

  useEffect(() => {
    setProgress(`${(parseInt(currentStep) / total) * 100}%`);
  }, [setProgress, currentStep, total]);

  // Success screen doesn't have Steps
  if (currentStep === 'success') return null;

  function getCards(cardId) {
    return cards?.find(card => card.id === cardId);
  }

  function getCardTypes(cardId, types) {
    return types?.find(card => card.id === cardId);
  }

  function getStepContent() {
    let group = getCards(selectedGroup);
    let card = getCardTypes(selectedCard, group?.types);
    let title = group?.title;
    let subtitle = card?.brand + ' ' + card?.badge?.title;
    let cardImage = card?.thumbnail;

    return (
      <>
        <button className="steps-button" onClick={redirectToLanding}>
          <img className="steps-image" src={cardImage} alt="" />
        </button>

        <div className="steps-body">
          <strong>{title}</strong>
          <span>{subtitle}</span>
        </div>
      </>
    );
  }

  if (!isMobile) {
    return <StepsDesktop platinum={platinum} />;
  } else {
    return (
      <div className="steps-wrapper">
        <div className="steps">
          {getStepContent()}

          {/* {currentStep != 1 && <InfoButton onClick={onInfoClick} />} */}
          <InfoButton onClick={onInfoClick} />
        </div>

        <div className="progress-wrapper">
          <div className="progress">
            <div className="progress-indicator" />
          </div>

          {/* <span className="stepper">
            {step} / {total}
          </span> */}
        </div>

        <style jsx>{`
          .steps {
            align-items: center;
            display: flex;
            height: 46px;
          }

          .steps :global(.steps-image) {
            height: 40px;
            margin-right: 16px;
            max-width: 64px;
          }

          .steps-wrapper {
            background-color: ${colors.white};
            padding-top: 16px;
            padding-bottom: 10px;
            padding-left: 20px;
            padding-right: 20px;
            position: sticky;
            top: 0;
            z-index: 10;
          }

          .steps :global(.steps-button) {
            cursor: pointer;
            padding: 0;
            background: transparent;
            border: 0;
            font: inherit;
          }

          .steps :global(.steps-body) {
            display: flex;
            flex-direction: column;
            flex: 1;
            line-height: 1.35;
          }

          .steps :global(.steps-body strong) {
            font-size: 18px;
            font-weight: 900;
          }

          .steps :global(.steps-body span) {
            font-size: 14px;
          }

          .progress-wrapper {
            align-items: center;
            display: flex;
            margin-top: 16px;
          }

          .stepper {
            color: ${colors.brown};
            font-size: 13px;
            font-weight: 700;
            margin-left: 20px;
          }

          .progress {
            background-color: #f2edea;
            border-radius: 2px;
            flex: 1;
            height: 3px;
            position: relative;
            width: 100%;
          }

          .progress-indicator {
            background-color: ${colors.orange};
            border-radius: 2px;
            height: 3px;
            left: 0;
            position: absolute;
            top: 0;
            transition: width 0.35s ease-in-out;
          }
        `}</style>

        <style jsx>{`
          .progress-indicator {
            width: ${progress || '10%'};
          }
        `}</style>
      </div>
    );
  }
};

export default Steps;
